export const calculateCommission = ({
    kreditbetrag,
    provision,
}: {
    kreditbetrag?: number | null;
    provision: number | null;
}) => {
    if (!kreditbetrag || !provision) return null;

    const commission = (kreditbetrag * provision) / 100;

    // Round down only if there are more than two decimal places
    return Math.round(commission * 100) / 100;
};
